import { Pipe, PipeTransform } from "@angular/core";
import { LocalStorageService } from "../local-storage.service";
import { Country } from "../shared.service";

@Pipe({
    name: "nationality",
    standalone: false,
})
export class NationalityPipe implements PipeTransform {
    constructor(private _localStorageService: LocalStorageService) {}

    transform(id: number, key: string): string {
        const countries = this._localStorageService.getAppLocalStorageObject().countries;
        const country = countries.filter((c) => c.id === id)[0];
        return country ? country[key] : "N/D";
    }
}
